import { render } from "./CompaniaSeguros.vue?vue&type=template&id=6ec2ff74"
import script from "./CompaniaSeguros.vue?vue&type=script&lang=js"
export * from "./CompaniaSeguros.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__